
import { get } from "@rails/request.js"

export function subscribe()
{
  if (window.app.shipmentsIndexChannelSubscriptions == null) {

    window.app.shipmentsIndexChannelSubscriptions = window.app.consumer.subscriptions.create({
      channel: "ShipmentsUpdateChannel"
    },
    {
      received: update,
    })
  }
  
  return window.app.shipmentsIndexChannelSubscriptions;
}

export function unsubscribe(){
  if (window.app.shipmentsIndexChannelSubscriptions != null) {
    window.app.shipmentsIndexChannelSubscriptions.unsubscribe();
    window.app.shipmentsIndexChannelSubscriptions = null;
  }
}

async function update() {

  const updateDiv = document.getElementById("shipments-index-update-div");
  const url = updateDiv.getAttribute("data-update-url");

  const response = await get(url);

  if (response.ok)
    updateDiv.innerHTML = await response.text;

}
